export const ADD_ADMIN_WALLET_BALANCE = 'ADD_ADMIN_WALLET_BALANCE';
export const ADD_ADMIN_WALLET_BALANCE_SUCCEED = 'ADD_ADMIN_WALLET_BALANCE_SUCCEDD';
export const ADD_ADMIN_WALLET_BALANCE_FAILED = 'ADD_ADMIN_WALLET_BALANCE_FAILED';

export const FETCH_ALL_ERR_ERC20 = 'FETCH_ALL_ERR_ERC20';
export const FETCH_ALL_ERR_ERC20_SUCCEED = 'FETCH_ALL_ERR_ERC20_SUCCEED';
export const FETCH_ALL_ERR_ERC20_FAILED = 'FETCH_ALL_ERR_ERC20_FAILED';

export const FETCH_ALL_ERR_TOMO_ERC20 = 'FETCH_ALL_ERR_TOMO_ERC20';
export const FETCH_ALL_ERR_TOMO_ERC20_SUCCEED = 'FETCH_ALL_ERR_TOMO_ERC20_SUCCEED';
export const FETCH_ALL_ERR_TOMO_ERC20_FAILED = 'FETCH_ALL_ERR_TOMO_ERC20_FAILED';

export const FETCH_ADMIN_BALANCE = 'FETCH_ADMIN_BALANCE';
export const FETCH_ADMIN_BALANCE_SUCCEED = 'FETCH_ADMIN_BALANCE_SUCCEED';
export const FETCH_ADMIN_BALANCE_FAILED = 'FETCH_ADMIN_BALANCE_FAILED';

export const FETCH_ADMIN_WALLET = 'FETCH_ADMIN_WALLET';
export const FETCH_ADMIN_WALLET_SUCCEED = 'FETCH_ADMIN_WALLET_SUCCEED';
export const FETCH_ADMIN_WALLET_FAILED = 'FETCH_ADMIN_WALLET_FAILED';

export const MIGRATE_ETH = 'MIGRATE_ETH';
export const MIGRATE_ETH_SUCCEED = 'MIGRATE_ETH_SUCCEED';
export const MIGRATE_ETH_FAILED = 'MIGRATE_ETH_FAILED';

export const MIGRATE_ERC20 = 'MIGRATE_ERC20';
export const MIGRATE_ERC20_SUCCEED = 'MIGRATE_ERC20_SUCCEED';
export const MIGRATE_ERC20_FAILED = 'MIGRATE_ERC20_FAILED';

export const MIGRATE_BTC = 'MIGRATE_BTC';
export const MIGRATE_BTC_SUCCEED = 'MIGRATE_BTC_SUCCEED';
export const MIGRATE_BTC_FAILED = 'MIGRATE_BTC_FAILED';

export const FIX_ERR_ERC20 = 'FIX_ERR_ERC20';
export const FIX_ERR_ERC20_SUCCEED = 'FIX_ERR_ERC20_SUCCEED';
export const FIX_ERR_ERC20_FAILED = 'FIX_ERR_ERC20_FAILED';

export const FIX_ERR_TOMO_ERC20 = 'FIX_ERR_TOMO_ERC20';
export const FIX_ERR_TOMO_ERC20_SUCCEED = 'FIX_ERR_TOMO_ERC20_SUCCEED';
export const FIX_ERR_TOMO_ERC20_FAILED = 'FIX_ERR_TOMO_ERC20_FAILED';

export const SET_ADMIN_TRANSFER = 'SET_ADMIN_TRANSFER';
export const SET_ADMIN_TRANSFER_SUCCESS = 'SET_ADMIN_TRANSFER_SUCCESS';
export const SET_ADMIN_TRANSFER_FAILED = 'SET_ADMIN_TRANSFER_FAILED';
